<div class="flex flex-col gap-6 md:gap-4">
  @if (showPrivacyPolicyInfo()) {
  <p
    class="text-caption-regular text-gray-dark [&_a]:text-green [&_a]:underline"
    [innerHtml]="'common.agreements.consent-text' | translate"
  ></p>
  } @if (termsAndConditionsControl) {
  <div>
    <mat-checkbox
      class="enx-checkbox text-caption-regular text-gray-dark [&_a]:text-green [&_a]:underline"
      [formControl]="termsAndConditionsControl"
    >
      <span [innerHTML]="'common.agreements.terms-and-conditions-checkbox' | translate"></span>
    </mat-checkbox>
    <ng-content select="[termsAndConditionsCheckbox]"></ng-content>
  </div>
  }

  <mat-checkbox class="enx-checkbox text-caption-regular text-gray-dark" [formControl]="newsletterControl">
    {{ 'common.agreements.newsletter-checkbox' | translate }}
  </mat-checkbox>
</div>
